import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPolicyDropdownOpen, setIsPolicyDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const togglePolicyDropdown = () => {
    setIsPolicyDropdownOpen(!isPolicyDropdownOpen);
  };
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsPolicyDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return <header className="bg-[#0a3d62] text-white shadow-md" data-id="element-126">
      <div className="container mx-auto px-4 py-4" data-id="element-127">
        <div className="flex justify-between items-center" data-id="element-128">
          <Link to="/" className="flex items-center space-x-2" data-id="element-129">
            <div className="font-bold text-2xl text-white" data-id="element-130">
              <span className="text-[#3fc1c9]" data-id="element-131">Pinnacle</span>Hub
            </div>
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-6" data-id="element-132">
            <Link to="/" className="hover:text-[#3fc1c9] transition-colors" data-id="element-133">
              Home
            </Link>
            <Link to="/service-coverage" className="hover:text-[#3fc1c9] transition-colors" data-id="element-134">
              Service Coverage
            </Link>
            <Link to="/about" className="hover:text-[#3fc1c9] transition-colors" data-id="element-135">
              About Us
            </Link>
            <Link to="/contact" className="hover:text-[#3fc1c9] transition-colors" data-id="element-136">
              Contact Us
            </Link>
            <Link to="/faq" className="hover:text-[#3fc1c9] transition-colors" data-id="element-137">
              FAQs
            </Link>
            {/* Policies Dropdown */}
            <div className="relative" ref={dropdownRef} data-id="element-138">
              <button className="flex items-center hover:text-[#3fc1c9] transition-colors" onClick={togglePolicyDropdown} data-id="element-139">
                Policies <ChevronDownIcon size={16} className="ml-1" data-id="element-140" />
              </button>
              {isPolicyDropdownOpen && <div className="absolute right-0 mt-2 w-64 bg-white rounded-md shadow-lg py-1 z-50" data-id="element-141">
                  <Link to="/cancellation-policy" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => setIsPolicyDropdownOpen(false)} data-id="element-142">
                    Cancellation Policy
                  </Link>
                  <Link to="/refund-policy" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => setIsPolicyDropdownOpen(false)} data-id="element-143">
                    Refund Policy
                  </Link>
                  <Link to="/privacy-policy" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => setIsPolicyDropdownOpen(false)} data-id="element-144">
                    Privacy & Cookie Policy
                  </Link>
                  <Link to="/terms-conditions" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => setIsPolicyDropdownOpen(false)} data-id="element-145">
                    Terms & Conditions
                  </Link>
                </div>}
            </div>
          </nav>
          {/* Mobile menu button */}
          <button className="md:hidden text-white focus:outline-none" onClick={toggleMenu} data-id="element-146">
            {isMenuOpen ? <XIcon size={24} data-id="element-147" /> : <MenuIcon size={24} data-id="element-148" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden mt-4 pb-4" data-id="element-149">
            <nav className="flex flex-col space-y-3" data-id="element-150">
              <Link to="/" className="hover:text-[#3fc1c9] transition-colors" onClick={toggleMenu} data-id="element-151">
                Home
              </Link>
              <Link to="/service-coverage" className="hover:text-[#3fc1c9] transition-colors" onClick={toggleMenu} data-id="element-152">
                Service Coverage
              </Link>
              <Link to="/about" className="hover:text-[#3fc1c9] transition-colors" onClick={toggleMenu} data-id="element-153">
                About Us
              </Link>
              <Link to="/contact" className="hover:text-[#3fc1c9] transition-colors" onClick={toggleMenu} data-id="element-154">
                Contact Us
              </Link>
              <Link to="/faq" className="hover:text-[#3fc1c9] transition-colors" onClick={toggleMenu} data-id="element-155">
                FAQs
              </Link>
              <div className="pt-2 border-t border-[#1e5f82]" data-id="element-156">
                <p className="text-sm text-gray-300 mb-2" data-id="element-157">Policies:</p>
                <Link to="/cancellation-policy" className="block text-sm hover:text-[#3fc1c9] transition-colors mb-1" onClick={toggleMenu} data-id="element-158">
                  Cancellation Policy
                </Link>
                <Link to="/refund-policy" className="block text-sm hover:text-[#3fc1c9] transition-colors mb-1" onClick={toggleMenu} data-id="element-159">
                  Refund Policy
                </Link>
                <Link to="/privacy-policy" className="block text-sm hover:text-[#3fc1c9] transition-colors mb-1" onClick={toggleMenu} data-id="element-160">
                  Privacy & Cookie Policy
                </Link>
                <Link to="/terms-conditions" className="block text-sm hover:text-[#3fc1c9] transition-colors" onClick={toggleMenu} data-id="element-161">
                  Terms & Conditions
                </Link>
              </div>
            </nav>
          </div>}
      </div>
    </header>;
};
export default Header;